const INITIAL_STATE = {
  proProfile: {},
  proPortfolio: [],
};

/**
 * Types
 */
export const Types = {
  GET_PRO_PROFILE_REQUEST: 'pro/GET_PRO_PROFILE_REQUEST',
  GET_PRO_PORTFOLIO_REQUEST: 'pro/GET_PRO_PORTFOLIO_REQUEST',
  GET_PRO_PROFILE_SUCCESS: 'pro/GET_PRO_PROFILE_REQUEST',
  GET_PRO_PORTFOLIO_SUCCESS: 'pro/GET_PRO_PORTFOLIO_REQUEST',
};

/**
 * Reducer
 */
export default function tasks(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_PRO_PROFILE_SUCCESS: {
      return { ...state, proProfile: action.payload };
    }
    case Types.GET_PRO_PORTFOLIO_SUCCESS: {
      return { ...state, proPortfolio: action.payload };
    }
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  getProProfileRequest: payload => ({
    type: Types.GET_PRO_PROFILE_REQUEST,
    payload,
  }),
  getProPortfolioRequest: payload => ({
    type: Types.GET_PRO_PORTFOLIO_REQUEST,
    payload,
  }),
  getProProfileSuccess: payload => ({
    type: Types.GET_PRO_PROFILE_SUCCESS,
    payload,
  }),
  getProPortfolioSuccess: payload => ({
    type: Types.GET_PRO_PORTFOLIO_SUCCESS,
    payload,
  }),
};
